import {
  LoginView,
  SetPasswordView,
  ForgotPasswordView,
  ResetPasswordView,
} from '@/views/anonymous/auth';

export default [
  {
    path: '/login',
    name: 'app_auth_login',
    meta: { title: 'Log In' },
    component: LoginView,
  },
  {
    path: '/set-password',
    name: 'app_auth_set_password',
    component: SetPasswordView,
    meta: { title: 'Set Password' },
  },
  {
    path: '/forgot-password',
    name: 'app_auth_forgot_password',
    meta: { title: 'Forgot Password' },
    component: ForgotPasswordView,
  },
  {
    path: '/reset-password',
    name: 'app_auth_reset_password',
    meta: { title: 'Reset Password' },
    component: ResetPasswordView,
  },
];
